import '../components/filters.js'

document.addEventListener('change', (event) => {
    if (event.target.matches('#mobile-category')) {
        const categorySlug = event.target.value
        window.location.replace('/directory?category=' + categorySlug)
    }
})
